import React, { useRef } from "react";
import { func, bool } from "prop-types";
import { useTranslation } from "@lib/i18n";

import Modal from "@components/shared/Modal";
import ButtonGroup from "@components/shared/ButtonGroup";
import Typography from "@components/shared/Typography";
import { Button } from "@components/shared/Button";
import RequestButton from "@components/shared/RequestButton";

import { basketRegistrationConfirmRejectEvent } from "@gtm/events/basket";
import gtm from "@gtm/core";

const ConfirmChoiceModal = ({
  rejectHandle,
  isOpen,
  triggerRequestCallback,
  onRequestSuccess,
}) => {
  const { t } = useTranslation();

  const modalFirstElement = useRef(null);
  const modalLastElement = useRef(null);

  const onConfirmClick = async () => {
    gtm.fire(
      basketRegistrationConfirmRejectEvent({
        label: t("basket.vehicleRegistration.confirmChoiceModal.confirm"),
      })
    );

    await triggerRequestCallback();

    await onRequestSuccess();

    return new Promise(() => null);
  };

  return (
    <Modal
      isOpen={isOpen}
      firstElement={modalFirstElement}
      lastElement={modalLastElement}
      ariaLabel={t("basket.vehicleRegistration.confirmChoiceModal.message")}
      onClose={rejectHandle}
    >
      <div className="flex flex-col gap-4 pr-4">
        <Typography size="md">
          {t("basket.vehicleRegistration.confirmChoiceModal.message")}
        </Typography>
        <ButtonGroup>
          <RequestButton
            ref={modalFirstElement}
            data-id="basket-vehicleRegistration-confirmChoiceModal-confirm"
            triggerRequestCallback={onConfirmClick}
          >
            {t("basket.vehicleRegistration.confirmChoiceModal.confirm")}
          </RequestButton>
          <Button
            ref={modalLastElement}
            variant="secondary"
            data-id="basket-vehicleRegistration-confirmChoiceModal-change"
            onClick={() => {
              gtm.fire(
                basketRegistrationConfirmRejectEvent({
                  label: t(
                    "basket.vehicleRegistration.confirmChoiceModal.change"
                  ),
                })
              );

              rejectHandle();
            }}
          >
            {t("basket.vehicleRegistration.confirmChoiceModal.change")}
          </Button>
        </ButtonGroup>
      </div>
    </Modal>
  );
};

ConfirmChoiceModal.propTypes = {
  rejectHandle: func.isRequired,
  triggerRequestCallback: func.isRequired,
  onRequestSuccess: func.isRequired,
  isOpen: bool.isRequired,
};

export default ConfirmChoiceModal;
